import { IResourceFieldDescriptor } from '~/client/src/shared/resources/catalog/types'

export const isVisibleResourceColumnField = (
  field: IResourceFieldDescriptor,
  visibleFieldKeys: Set<string>,
): boolean => field.source === 'static' || visibleFieldKeys.has(field.key)

export const shouldCreateHiddenBehaviorColumn = (
  field: IResourceFieldDescriptor,
  visibleFieldKeys: Set<string>,
): boolean =>
  !isVisibleResourceColumnField(field, visibleFieldKeys) &&
  (field.capabilities.filterable || field.capabilities.searchable)
